import { isUserLogged } from "@creditas/hr-mf-utils";
import { isMfLoginRoute } from "./domain/util";
import { registerApplication, start } from "single-spa";
import i18n from "./i18n";

registerApplication({
  name: "@creditas/hr-mf-login",
  app: () => System.import("@creditas/hr-mf-login"),
  activeWhen: (location) =>
    isMfLoginRoute(location.pathname) || !isUserLogged(),
  customProps: {
    loginSuccessUrl: "/",
    i18n,
  },
});

registerApplication({
  name: "@creditas/hr-mf-portal",
  app: () => System.import("@creditas/hr-mf-portal"),
  activeWhen: (location) =>
    !isMfLoginRoute(location.pathname) && isUserLogged(),
  customProps: {
    i18n,
  },
});

start({
  urlRerouteOnly: true,
});
